// extracted by mini-css-extract-plugin
module.exports = {"page":"menu_page__pmsg3","menu-column":"menu_menu-column__EpbZA"};